define('lq/events/actions/pain001ExportCommand',[
    'lq/events/actions/eventAction',
    'jquery',
    'lq',
    'lq/cookie',
    'lq/formSubmission'
], function (EventAction, $, lq, cookie, FormSubmission) {
    'use strict';

    function Pain001ExportCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(Pain001ExportCommand, EventAction);

    Pain001ExportCommand.typeName = 'Pain001ExportCommand';

    Pain001ExportCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    Pain001ExportCommand.prototype.createEventActionRequest = function() {
        if (this.eventData.downloadOnly)
            return undefined;

        return {
            eventActionType: 'Pain001Export',
            command: this.eventData.command
        };
    };

    Pain001ExportCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (this.eventData.downloadOnly) {
            var token = 'pain0001-export-' + Date.now();

            var form = new FormSubmission(this.piping.url.prepare(lq.getTenantUrl('Export/Pain001')));
            form.addProperty('actionId', this.piping.actionId);
            form.addProperty('pain001ExportId', this.eventData.command);
            form.addProperty('token', token);
            form.addParameters('parameters', this.piping.parameters.getNonSystemParameters());
            form.submit();

            var waitWhileDownloadIsStarting = function() {
                if (cookie.get(token) === null)
                    setTimeout(waitWhileDownloadIsStarting, 200);
                else
                    continuation();
            };
            waitWhileDownloadIsStarting();
        } else if (eventActionResponse.download) {
            var queryString = {
                url: eventActionResponse.url,
                filename: eventActionResponse.filename,
                openInBrowser: false
            };
            window.location = this.piping.url.prepare(lq.getTenantUrl('DynamicContent/DownloadFile'), queryString);
            continuation();
        } else {
            continuation();
        }
    };

    return Pain001ExportCommand;
});
